/* ==============================================================
   pe-zoho-loader.js

   Adds a loading state to the Zoho "Get Started with our Planning
   Experts" lightbox on product pages.

   WHY
   The lightbox JS (inline in the "Form Launcher" block in
   templates/product.json and the "Get Started Button" block in
   templates/product.instant-quote.json) creates the iframe and appends
   it the instant the button is clicked. Fetching the Zoho form then
   takes several seconds, during which the panel is a blank white box
   with no indication that anything is happening.

   HOW
   The iframe always goes into the same container id, so a
   MutationObserver on that container catches the insertion, shows an
   overlay and hides the iframe until the iframe's load event fires.
   The lightbox removes the iframe when it closes, which puts the loading
   state back, so the next open behaves the same way with no extra
   bookkeeping.

   The overlay is a real element rather than ::before / ::after because
   it carries two lines of copy at different sizes and weights, which is
   more than two pseudo-elements can express cleanly. It also lets the
   block be centred with flexbox instead of a guessed top percentage.

   role="status" with aria-live="polite" announces the wait to screen
   readers once, without stealing focus.

   This file deliberately does not modify the template JS. The container
   id below is the only coupling between them. If that id ever changes in
   the templates, change it here too.

   Companion CSS is in assets/pe-overrides.css, section 1c.
   ============================================================== */
(function () {
  var HOST_ID = 'zz0k51SGc2VUVlFthSmZD5pmVHKGSWmu1XIGL3F-O3M_47991';
  var LOADING_CLASS = 'pe-zf-loading';
  var OVERLAY_CLASS = 'pe-zf-overlay';
  var LEAD_TEXT = "First, let's get some info from you...";
  var SUB_TEXT = 'Loading your planning form';
  var SAFETY_TIMEOUT = 15000;
  var attempts = 0;

  function buildOverlay() {
    var overlay = document.createElement('div');
    overlay.className = OVERLAY_CLASS;
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');

    var spinner = document.createElement('div');
    spinner.className = OVERLAY_CLASS + '__spinner';
    spinner.setAttribute('aria-hidden', 'true');

    var lead = document.createElement('p');
    lead.className = OVERLAY_CLASS + '__lead';
    lead.textContent = LEAD_TEXT;

    var sub = document.createElement('p');
    sub.className = OVERLAY_CLASS + '__sub';
    sub.textContent = SUB_TEXT;

    overlay.appendChild(spinner);
    overlay.appendChild(lead);
    overlay.appendChild(sub);
    return overlay;
  }

  function ensureOverlay(host) {
    var existing = host.querySelector('.' + OVERLAY_CLASS);
    if (existing) return existing;

    var overlay = buildOverlay();
    host.appendChild(overlay);
    return overlay;
  }

  function startLoading(host) {
    ensureOverlay(host);
    host.classList.add(LOADING_CLASS);
  }

  function bindIframe(host, iframe) {
    var settled = false;

    function clear() {
      if (settled) return;
      settled = true;
      host.classList.remove(LOADING_CLASS);
    }

    startLoading(host);
    iframe.addEventListener('load', clear);

    /* If the form never loads, stop spinning and reveal whatever is
       there rather than leaving an indefinite spinner on screen. */
    window.setTimeout(clear, SAFETY_TIMEOUT);
  }

  function watch() {
    var host = document.getElementById(HOST_ID);

    /* constructDiv_47991() builds this container on window load, so it
       may not exist yet depending on script order. Retry briefly, then
       give up quietly. */
    if (!host) {
      attempts += 1;
      if (attempts < 20) window.setTimeout(watch, 500);
      return;
    }

    startLoading(host);

    var existing = host.getElementsByTagName('iframe')[0];
    if (existing) bindIframe(host, existing);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].tagName === 'IFRAME') bindIframe(host, added[j]);
        }

        var removed = mutations[i].removedNodes;
        for (var k = 0; k < removed.length; k++) {
          if (removed[k].tagName === 'IFRAME') startLoading(host);
        }
      }
    }).observe(host, { childList: true });
  }

  if (document.readyState === 'complete') {
    watch();
  } else {
    window.addEventListener('load', watch);
  }
})();
